module.exports = __webpack_public_path__ + "img/logoMain2.30b333db.png";